import React from 'react';
import { Route, Switch } from 'react-router';
import ViewDisciplineGroupRules from './view';
import EditDisciplineGroupRules from './edit';

const DisciplineGroupRules = () => {
    return (
        <Switch>
            <Route exact path='/admin/disciplineGroupRules' component={ViewDisciplineGroupRules} />
            <Route exact path='/admin/disciplineGroupRules/:id' component={EditDisciplineGroupRules} />
        </Switch>
    );
};

export default DisciplineGroupRules;
